import { Directive, OnDestroy, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { GTranslateWidgetService } from '../services/gtranslate-widget.service';

/**
 * Directive applied to every 'mat-select' element that triggers a GTranslate
 * re-translation after the user changes the selected value.
 *
 * When a 'mat-select' value changes, the rendered option text is replaced by
 * Angular Material, causing GTranslate to lose its translation of the new
 * display value. This directive listens for 'selectionChange' and calls
 * 'GTranslateWidgetService.retranslate()' in a 'setTimeout' so the DOM has
 * settled before GTranslate re-scans it.
 */
@Directive({
  selector: 'mat-select',
  standalone: true,
})
export class MatSelectRetranslateDirective implements OnInit, OnDestroy {
  private sub: Subscription | null = null;

  constructor(
    private matSelect: MatSelect,
    private gTranslateService: GTranslateWidgetService
  ) {}

  ngOnInit(): void {
    this.sub = this.matSelect.selectionChange.subscribe(() => {
      setTimeout(() => this.gTranslateService.retranslate());
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
